import { Typography } from '@mui/material';
import InfoValueRow from '@shared/components/InfoValueRow';
import { currency } from '@shared/hooks/currencies';
import HorizontalSeparator from '@shared/pages/Flights/components/HorizontalSeparator';

const AssistPaymentDetails = ({
  total,
  totalUsd = 0,
  isInUSD = false,
  currencyValue,
  hasCharges,
}) => {
  const showTotalUSD = totalUsd > 0 && Number(total) !== Number(totalUsd);

  return (
    <>
      <HorizontalSeparator color="#E5E5E5" />
      {showTotalUSD && (
        <InfoValueRow label="Total" value={totalUsd} isPrice isInUSD mb={1} />
      )}
      <InfoValueRow
        label="Total"
        value={total}
        isPrice
        boldLeft
        boldRight
        color="red"
        fontSize={{ xs: '17px', md: '18px', lg: '15px', xl: '18px' }}
        isInUSD={isInUSD}
      />
      {currencyValue > 0 && (
        <Typography
          sx={{
            fontSize: { xs: 12, md: 13 },
            alignSelf: 'start',
            lineHeight: 'normal',
          }}
        >
          Tipo de cambio: {currency(currencyValue)}
        </Typography>
      )}
      {!hasCharges && (
        <Typography
          sx={{
            fontSize: { xs: 12, md: 13 },
            alignSelf: 'start',
            lineHeight: 'normal',
          }}
        >
          Las tarifas publicadas no incluyen gastos administrativos.
        </Typography>
      )}
      {hasCharges && (
        <Typography
          sx={{
            fontSize: { xs: 12, md: 13 },
            alignSelf: 'start',
            lineHeight: 'normal',
          }}
        >
          Las tarifas publicadas incluyen gastos administrativos.
        </Typography>
      )}
    </>
  );
};

export default AssistPaymentDetails;
